import API from '../api';

export const certApi = {
  // Single Operations
  issueSingle: (formData, user) => 
    API.post('/certificates/issue-pdf-text', formData, {
      headers: { 'Content-Type': 'multipart/form-data', 'x-user-identity': user }
    }),

  verifySingle: (formData, user) => 
    API.post('/certificates/verify-pdf-text', formData, {
      headers: { 'Content-Type': 'multipart/form-data', 'x-user-identity': user }
    }),

  getHistory: (certHash, user) => 
    API.get(`/certificates/history/${certHash}`, {
      headers: { 'x-user-identity': user }
    }),

  revokeCert: (certHash, reason, user) => 
    API.post('/certificates/revoke', { certHash, reason }, {
      headers: { 'x-user-identity': user }
    }),

  verifyByHash: (certHash, user) => 
    API.get(`/certificates/verify/${certHash}`, {
      headers: { 'x-user-identity': user }
    }),

  // Bulk Operations
  queueBulkBatch: (formData, user) => 
    API.post('/certificates/queue-zip-batch', formData, {
      headers: { 'Content-Type': 'multipart/form-data', 'x-user-identity': user }
    }),

  pollBatchStatus: (jobId) => 
    API.get(`/certificates/batch-status/${jobId}`)
};